export default __webpack_public_path__ + "static/media/hamburger.43aa3a38.svg";